export const ENTRIES_START = 'ENTRIES_START';

export const ENTRIES_SUCCESS= 'ENTRIES_SUCCESS';

export const ENTRIES_FAIL = 'ENTRIES_FAIL';

export const AUTH_START = 'AUTH_START'

export const AUTH_SUCCESS = 'AUTH_SUCCESS'

export const AUTH_FAIL = 'AUTH_FAIL'

export const DElETE_START = 'DELETE_START'

export const DElETE_SUCCESS = 'DElETE_SUCCESS'

export const DElETE_FAIL = 'DElETE_FAIL'


